import { Popover, Transition } from "@headlessui/react";
import {
  MenuIcon,
  XIcon,
} from "@heroicons/react/outline"
import { Logout } from "@mui/icons-material";
import React, { Fragment } from "react";
import { Link, NavLink } from "react-router-dom";
import { ENDPOINT, Routes } from "../../constants";

import { useAuth } from "../../contexts/AuthContext";
import Button from "../Button";
import { FetchApi } from "../../api/fetch";

const AppBar = React.memo(() => {
  const {
    currentUser,
    logout,
    isCurrentUserAdmin,
    isCurrentUserCreator,
    getUserJWT,
    isCurrentUserReviewer,
    setIsLoadingOverlayDisplay
  } = useAuth();

  // const { currentBlockchain, setCurrentBlockchain }: any = useBlockchain()
  const active = {
    borderBottom: "3px solid skyblue"
  }


  const downloadAttendance = async () => {
    setIsLoadingOverlayDisplay(true)
    const userJWT = await getUserJWT()

    try {
      const blob = await FetchApi({
        endpoint: `${ENDPOINT.BASE_ENDPOINT_TELEGRAM}/get-stats`,
        method: "POST",
        JWT: userJWT,
        format:'blob'
      })

      const url = window.URL.createObjectURL(blob);
      window.location.assign(url);

    } catch (error) {
      console.log(error);
    }
    setIsLoadingOverlayDisplay(false)
  }

  return (
    <Popover className="bg-kyzzen-secondary sticky top-0 z-50">
      {({ open, close }) => (
        <>
          <div className="flex justify-between items-center px-4 sm:px-6 md:justify-start md:space-x-10 mx-auto shadow bg-kyzzen-secondary">
            <div className="-ml-1 flex justify-start lg:w-0 md:flex-auto sm:h-20 h-12">
              <Link
                to={Routes.DASHBOARD}
                onClick={() => close()}
                className="flex items-center"
              >
                <img
                  src="/assets/logo/kyzzen.png"
                  alt="kyzzen logo"
                  className="w-auto md:h-7.5"
                />
              </Link>
            </div>
            <div className="-mr-2 -my-2 lg:hidden">
              <Popover.Button className="bg-almost-black p-2 inline-flex items-center justify-center text-white hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500">
                <span className="sr-only">Open menu</span>
                <MenuIcon className="h-6 w-6" aria-hidden="true" />
              </Popover.Button>
            </div>
            <Popover.Group
              as="nav"
              className="hidden lg:flex space-x-10 items-center"
            >

              {!!currentUser && (
                <div className="flex items-center gap-4">
                  <Button
                    onClick={logout}
                    className="font-light uppercase cursor-pointer w-40 text-sm flex items-center"
                  >
                    LOG OUT
                    <Logout className="ml-2" />
                  </Button>
                </div>

              )}
            </Popover.Group>
          </div>

          <Transition
            show={open}
            as={Fragment}
            enter="duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              static
              className="absolute top-0 inset-x-0 z-10 transition transform origin-top-right lg:hidden bg-kyzzen-primary"
            >
              <div className="ring-1 ring-white ring-opacity-5 p-2 bg-almost-black divide-y-2 divide-gray-50">
                <div className="pt-5 pb-6 px-5">
                  <div className="flex items-center justify-between">
                    <div>
                      <Link
                        to={Routes.DASHBOARD}
                        onClick={() => close()}
                        className="flex items-center"
                      >
                        <img
                          src="/assets/logo/kyzzen.png"
                          alt="kyzzen logo"
                          className="w-auto md:h-7.5"
                        />
                      </Link>
                    </div>
                    <div className="-mr-2">
                      <Popover.Button className="bg-almost-black border border-white p-2 inline-flex items-center justify-center text-white hover:bg-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500">
                        <span className="sr-only">Close menu</span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </Popover.Button>
                    </div>
                  </div>
                  <div className="mt-6">
                    <nav className="grid grid-cols-1 gap-7">
                      <Link
                        to={Routes.LOGIN}
                        onClick={() => close()}
                        className="-m-3 p-3 flex items-center"
                      >
                        <div className="font-light text-white uppercase hover:text-gray-500 text-md">
                          Home
                        </div>
                      </Link>

                      {!!currentUser && (isCurrentUserCreator() || isCurrentUserReviewer()) && (
                        <div className="mt-8 mb-4">
                          <div>
                            <NavLink className="font-light text-white hover:text-gray-500 uppercase text-sm pb-1" to={Routes.MANAGE_COLLECTIONS} activeStyle={active}> Collections </NavLink>
                          </div>
                        </div>
                      )}

                      {!!currentUser && isCurrentUserAdmin() && (<>
                        <div className="mt-8 mb-4">
                          <div>
                            <NavLink className="font-light text-white hover:text-gray-500 uppercase text-sm pb-1" to={Routes.ADMIN_NOTIFICATIONS} activeStyle={active}>Notifications</NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <NavLink className="font-light text-white hover:text-gray-500 uppercase text-sm" to={Routes.SOLO_VERIFICATION} activeStyle={active}> Solo </NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <NavLink className="font-light text-white hover:text-gray-500 uppercase text-sm" to={Routes.FEATURED_COLLECTION} activeStyle={active}> Featured </NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <NavLink className="font-light text-white hover:text-gray-500 uppercase text-sm" to={Routes.MANAGE_DELETED} activeStyle={active}> Deleted </NavLink>
                          </div>
                        </div>
                      </>)}
                      {!!currentUser && isCurrentUserAdmin() && (<>

                        <div className="my-6">
                          <div>
                            <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500 text-sm pb-1" to={Routes.DELETE_LISTING} activeStyle={active}>
                              Delete Listing
                            </NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.MANAGE_DELETED} activeStyle={active}>
                              Deleted Collections
                            </NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <NavLink className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm" to={Routes.TELEGRAM} activeStyle={active}>
                              Telegram
                            </NavLink>
                          </div>
                        </div>
                        <div className="my-6">
                          <div>
                            <button onClick={downloadAttendance} className="w-full font-normal text-gray-40 flex items-center justify-start pl-12 py-4 hover:text-gray-500  text-sm">
                              Telegram Stats
                            </button>
                          </div>
                        </div>
                      </>)}

                      {!!currentUser && (
                        <Button
                          onClick={logout}
                          className="font-light uppercase cursor-pointer w-full text-sm text-right flex items-center"
                        >
                          LOG OUT
                          <Logout className="ml-2" />
                        </Button>
                      )}
                    </nav>
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
          {/* <hr className="border-0 m-0 h-0.5 bg-gradient-to-r from-accent-green to-solana-teal" /> */}
        </>
      )}
    </Popover>
  );
});

export default AppBar;
